
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    isDev() {
      return process.env.NODE_ENV === 'development'
    },
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
  },
}
